<template>
    <div class="light-spot" :style="bcStyle">
        <span class="title" v-html="$getConfigText(block.inner.title)"></span>
        <div class="inner">
            <img v-if="block.inner.imgPos === 'left'"
                class="left"
                :src="block.inner.img"/>
            <div class="intro">
                <span class="intro-title"
                    v-html="$getConfigText(block.inner.introTitle)">
                </span>
                <span class="intro-content"
                    v-html="$getConfigText(block.inner.introContent)">
                </span>
                <span v-if="block.isLink"
                    v-show="block.linkForm.status"
                    class="intro-link"
                    :style="linkStyle"
                    @click="goLink">
                    {{ $getConfigText(block.linkForm.text) }}
                </span>
            </div>
            <img v-if="block.inner.imgPos === 'right'"
                class="right"
                :src="block.inner.img"/>
        </div>
    </div>
</template>

<style scoped>
.light-spot {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 60px 0;
}
.title {
    width: 1012px;
    font-size: 34px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 60px;
}
.inner {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.inner > img {
    width: 600px;
    height: 420px;
}
.intro {
    display: flex;
    flex-direction: column;
    width: 540px;
}
.intro-title {
    font-size: 36px;
    font-weight: bold;
    margin-bottom: 32px;
}
.intro-content {
    font-size: 20px;
    line-height: 36px;
    margin-bottom: 46px;
}
.intro-link {
    font-size: 20px;
    font-weight: 500;
    color: #2c84dd;
    cursor: pointer;
}
img.left {
    margin-right: 60px;
}
img.right {
    margin-left: 60px;
}
</style>

<script>
export default {
    props: {
        block: Object
    },
    computed: {
        bcStyle() {
            return `background:${this.block.backColor};`;
        },
        linkStyle() {
            if (this.block.isLink) {
                return `color:${this.block.linkForm.textColor};`;
            } else {
                return "";
            }
        },
    },
    methods: {
        goLink(){
            window.open(this.block.linkForm.url)
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/templates/blocks/light-spot.vue